import { 
  Home, Users, CalendarDays, Building2, Building, Landmark, UserCheck, Calculator, 
  FolderOpen, GitMerge, FileSignature, Newspaper, Inbox, Leaf, 
  Megaphone, Settings, BarChart3, Shield, LayoutGrid, Image as ImageIcon,
  Briefcase, DollarSign, PieChart, Target, ClipboardList, Monitor, Smartphone, Globe, 
  Cloud, Database, Key, BookOpen, GraduationCap, Plane, Truck, ShoppingCart, Heart, 
  Zap, Coffee, Music, Video, Camera, Mic, Map, Compass, Clock, Bell, Bookmark, Tag, Gift,
  Folder
} from 'lucide-react';

// Dicionário para converter o nome salvo no banco de volta para o ícone visual
export const ICON_MAP = {
    Landmark, Building, Users, CalendarDays, Building2, UserCheck, Calculator, FolderOpen,
    GitMerge, FileSignature, Newspaper, Inbox, Leaf, Megaphone, Settings,
    BarChart3, Home, Folder, Shield, LayoutGrid, ImageIcon, Briefcase, DollarSign, 
    PieChart, Target, ClipboardList, Monitor, Smartphone, Globe, Cloud, Database, 
    Key, BookOpen, GraduationCap, Plane, Truck, ShoppingCart, Heart, Zap, Coffee, 
    Music, Video, Camera, Mic, Map, Compass, Clock, Bell, Bookmark, Tag, Gift
};

export const COLOR_PRESETS = [
    { label: 'Azul e Ciano', value: 'from-blue-600 to-cyan-500' },
    { label: 'Roxo e Fúcsia', value: 'from-purple-600 to-fuchsia-500' },
    { label: 'Esmeralda e Teal', value: 'from-emerald-600 to-teal-400' },
    { label: 'Rosa e Rose', value: 'from-pink-600 to-rose-400' },
    { label: 'Laranja e Âmbar', value: 'from-orange-500 to-amber-400' },
    { label: 'Índigo e Azul', value: 'from-indigo-600 to-blue-500' },
    { label: 'Vermelho e Laranja', value: 'from-red-600 to-orange-500' },
    { label: 'Cinza Escuro (Adm)', value: 'from-slate-600 to-slate-800' }
];

export const MODULES = [
  { id: '01', title: 'Clientes', icon: Users, color: 'from-blue-600 to-cyan-500' },
  { id: '05', title: 'Deptos', icon: Building2, color: 'from-emerald-600 to-teal-400' },
  { 
    id: '05.01', 
    title: 'CTB', 
    parentId: '05', 
    order: 1, 
    icon: Coffee, 
    iconName: 'Coffee', 
    color: 'from-pink-600 to-rose-400', 
    url: 'https://apex-ctb.web.app/' 
  },
  { 
    id: '05.02', 
    title: 'FSC', 
    parentId: '05', 
    order: 2, 
    icon: DollarSign, 
    iconName: 'DollarSign', 
    color: 'from-slate-500 to-slate-600', 
    url: 'https://apex-fsc.web.app/' 
  },
  { 
    id: '05.03', 
    title: 'DPS', 
    parentId: '05', 
    order: 3, 
    icon: Users, 
    iconName: 'Users', 
    color: 'from-blue-600 to-cyan-500', 
    url: '' 
  },
  { 
    id: '05.04', 
    title: 'REG', 
    parentId: '05', 
    order: 4, 
    icon: FileSignature, 
    iconName: 'FileSignature', 
    color: 'from-indigo-600 to-blue-500', 
    url: '' 
  },
  { 
    id: '05.05', 
    title: 'CS', 
    parentId: '05', 
    order: 5, 
    icon: Heart, 
    iconName: 'Heart', 
    color: 'from-rose-500 to-pink-500', 
    url: '' 
  },
  { 
    id: '05.06', 
    title: 'ADM', 
    parentId: '05', 
    order: 6, 
    icon: Briefcase, 
    iconName: 'Briefcase', 
    color: 'from-slate-600 to-slate-800', 
    url: '' 
  },
  { 
    id: '05.07', 
    title: 'FIN', 
    parentId: '05', 
    order: 7, 
    icon: PieChart, 
    iconName: 'PieChart', 
    color: 'from-emerald-600 to-teal-500', 
    url: '' 
  },
  { 
    id: '10', 
    title: 'Pessoas', 
    icon: UserCheck, 
    color: 'from-pink-600 to-rose-400',
    url: 'https://apex-grupoacadcontabilidade.web.app/' // Módulo Externo (Iframe)
  },
  { id: '20', title: 'IRPF', icon: Calculator, color: 'from-orange-500 to-amber-400' },
  { id: '25', title: 'Pastas e GED', icon: FolderOpen, color: 'from-indigo-600 to-blue-500' },
  { id: '30', title: 'Processos e Obrigs', icon: GitMerge, color: 'from-violet-600 to-purple-600' },
  { id: '50', title: 'ESG', icon: Leaf, color: 'from-lime-500 to-green-600' },
  { id: '55', title: 'Mkt', icon: Megaphone, color: 'from-cyan-600 to-blue-700' },
  { 
    id: '99', 
    title: 'Admin & Configs', 
    icon: Settings, 
    color: 'from-slate-600 to-slate-800',
    isInternal: true // Sinaliza que roda nativamente no Hub
  },
  { id: '70', title: 'Indicadores', icon: BarChart3, color: 'from-rose-400 to-orange-400' },
];

export const CARD_SIZES = [
    { id: '1x1', label: '1x1 (Padrão)' },
    { id: '1x2', label: '1x2 (Alto)' },
    { id: '2x1', label: '2x1 (Largo)' },
    { id: '2x2', label: '2x2 (Grande)' },
    { id: '3x1', label: '3x1' },
    { id: '3x2', label: '3x2' },
    { id: '4x1', label: '4x1' },
    { id: '4x2', label: '4x2' },
    { id: '5x1', label: '5x1' },
    { id: '6x1', label: '6x1 (Tela Toda)' }
];

export const getSizeClass = (sizeId) => {
    const sizes = {
        '1x1': 'col-span-1 row-span-1', '1x2': 'col-span-1 row-span-2',
        '2x1': 'col-span-2 row-span-1', '2x2': 'col-span-2 row-span-2',
        '3x1': 'col-span-3 row-span-1', '3x2': 'col-span-3 row-span-2',
        '4x1': 'col-span-4 row-span-1', '4x2': 'col-span-4 row-span-2',
        '5x1': 'col-span-5 row-span-1', '6x1': 'col-span-6 row-span-1'
    };
    if (sizeId === 'large') return sizes['2x2'];
    if (sizeId === 'wide') return sizes['2x1'];
    if (sizeId === 'tall') return sizes['1x2'];
    if (sizeId === 'normal') return sizes['1x1'];
    return sizes[sizeId] || sizes['1x1'];
};

export const DEPT_PERMISSION_MODULES = [
    { id: 'mod_05_01', moduleId: '05.01', deptCode: 'CTB', appIds: ['ctb', '05.01', 'mod_05_01'], rootKey: 'ctb_app_view', label: 'Módulo: CTB (Contábil) (05.01)', key: 'access_mod_05_01', defaultAdm: true, isDeptModule: true },
    { id: 'mod_05_02', moduleId: '05.02', deptCode: 'FSC', appIds: ['fsc', '05.02', 'mod_05_02'], rootKey: 'fsc_app_view', label: 'Módulo: FSC (Fiscal) (05.02)', key: 'access_mod_05_02', defaultAdm: true, isDeptModule: true },
    { id: 'mod_05_03', moduleId: '05.03', deptCode: 'DPS', appIds: ['dps', '05.03', 'mod_05_03'], rootKey: 'dps_app_view', label: 'Módulo: DPS (Departamento Pessoal) (05.03)', key: 'access_mod_05_03', defaultAdm: true, isDeptModule: true },
    { id: 'mod_05_04', moduleId: '05.04', deptCode: 'REG', appIds: ['reg', '05.04', 'mod_05_04'], rootKey: 'reg_app_view', label: 'Módulo: REG (Registro / Legalização) (05.04)', key: 'access_mod_05_04', defaultAdm: true, isDeptModule: true },
    { id: 'mod_05_05', moduleId: '05.05', deptCode: 'CS',  appIds: ['cs', '05.05', 'mod_05_05'],  rootKey: 'cs_app_view',  label: 'Módulo: CS (Customer Success / Atendimento) (05.05)', key: 'access_mod_05_05', defaultAdm: true, isDeptModule: true },
    { id: 'mod_05_06', moduleId: '05.06', deptCode: 'ADM', appIds: ['adm', '05.06', 'mod_05_06'], rootKey: 'adm_app_view', label: 'Módulo: ADM (Administrativo) (05.06)', key: 'access_mod_05_06', defaultAdm: true, isDeptModule: true },
    { id: 'mod_05_07', moduleId: '05.07', deptCode: 'FIN', appIds: ['fin', '05.07', 'mod_05_07'], rootKey: 'fin_app_view', label: 'Módulo: FIN (Financeiro) (05.07)', key: 'access_mod_05_07', defaultAdm: true, isDeptModule: true }
];

export const PERMISSION_STRUCTURE = [
    { id: 'hub_corporativo', label: 'Hub Corporativo (Acesso Básico)', key: 'access_hub_basic' },
    { 
        id: 'mod_01', 
        label: 'Módulo: Clientes (01)', 
        key: 'access_mod_01',
        children: [
            {
                label: 'Menu: Gestão de Clientes',
                key: 'cli_menu_clientes',
                children: [
                    { label: 'Ver Lista de Clientes', key: 'cli_view_list' },
                    { label: 'Exportar Clientes (CSV)', key: 'cli_export_csv' },
                    { label: 'Importar Clientes (CSV)', key: 'cli_import_csv', defaultAdm: true },
                    { label: 'Adicionar Novo Cliente', key: 'cli_add_new' },
                    { label: 'Editar Cliente Existente', key: 'cli_edit_record' },
                    { label: 'Visualizar Detalhes do Cliente (Olho)', key: 'cli_view_details' }
                ]
            },
            {
                label: 'Menu: Contatos e Relacionamentos',
                key: 'cli_menu_contatos',
                children: [
                    { label: 'Ver Lista de Contatos', key: 'cnt_view_list' },
                    { label: 'Adicionar Novo Contato', key: 'cnt_add_new' },
                    { label: 'Editar Contato Existente', key: 'cnt_edit_record' }
                ]
            },
            {
                label: 'Menu: Sócios e Participações',
                key: 'cli_menu_socios',
                children: [
                    { label: 'Ver Quadro de Sócios (Por Empresa)', key: 'soc_view_by_company' },
                    { label: 'Ver Participações (Por Pessoa)', key: 'soc_view_by_person' },
                    { label: 'Gerenciar/Editar Sócios', key: 'soc_manage_records' }
                ]
            },
            {
                label: 'Menu: Visão de Grupos',
                key: 'cli_menu_grupos',
                children: [
                    { label: 'Pesquisar e Visualizar Ecossistemas', key: 'grp_view_ecosystem' }
                ]
            },
            {
                label: 'Menu: Funcionários Responsáveis',
                key: 'cli_menu_responsaveis',
                children: [
                    { label: 'Ver Carteira de Responsáveis', key: 'rsp_view_list' },
                    { label: 'Adicionar/Editar Vínculos', key: 'rsp_manage_links', defaultAdm: true }
                ]
            },
            {
                label: 'Menu: Processos FRAE (Legalização)',
                key: 'cli_menu_frae',
                children: [
                    { label: 'Ver Processos FRAE Ativos', key: 'frae_view_list' },
                    { label: 'Iniciar Nova FRAE', key: 'frae_add_new' },
                    { label: 'Editar Rascunho de FRAE', key: 'frae_edit_draft' },
                    { label: 'Gerar PDF para Assinatura', key: 'frae_generate_pdf' }
                ]
            },
            {
                label: 'Menu: Cadastros Gerais (Tabelas Base)',
                key: 'cli_menu_cadastros',
                defaultAdm: true,
                children: [
                    { label: 'Aba: UACs', key: 'cad_tab_uacs', defaultAdm: true },
                    { label: 'Aba: Células', key: 'cad_tab_celulas', defaultAdm: true },
                    { label: 'Aba: Deptos Internos', key: 'cad_tab_deptos', defaultAdm: true },
                    { label: 'Aba: Unidades de Referência', key: 'cad_tab_unidades', defaultAdm: true },
                    { label: 'Aba: Faixas de Códigos', key: 'cad_tab_faixas', defaultAdm: true },
                    { label: 'Aba: Códigos Bloqueados (Lista Negra)', key: 'cad_tab_bloqueados', defaultAdm: true },
                    { label: 'Aba: Grupos de Clientes', key: 'cad_tab_grupos', defaultAdm: true },
                    { label: 'Aba: Tipos de Clientes', key: 'cad_tab_tipos', defaultAdm: true },
                    { label: 'Aba: Segmentos', key: 'cad_tab_segmentos', defaultAdm: true },
                    { label: 'Aba: Usos de Senhas', key: 'cad_tab_senhas', defaultAdm: true },
                    { label: 'Aba: Formas de Tributação', key: 'cad_tab_tributacao', defaultAdm: true },
                    { label: 'Aba: Motivos de Saída', key: 'cad_tab_motivos', defaultAdm: true }
                ]
            },
            {
                label: 'Menu: Auditoria do Sistema',
                key: 'cli_menu_auditoria',
                defaultAdm: true
            }
        ]
    },
    ...DEPT_PERMISSION_MODULES,
    {
        id: 'av_desempenho',
        label: 'Projeto: Gestão de Pessoas',
        key: 'access_proj_av_desempenho', 
        children: [
            { label: 'Dashboard', key: 'access_dash', defaultAdm: true },
            { 
                label: 'Cadastros', 
                key: 'access_reg', 
                defaultAdm: true,
                children: [
                    { label: 'Departamentos', key: 'access_tab_dept' },
                    { label: 'Gestores', key: 'access_tab_manager' },
                    { 
                        label: 'Critérios Avaliação', 
                        key: 'access_tab_criteria',
                        children: [
                            { label: 'Lista de Critérios', key: 'access_sub_criteria_list' },
                            { label: 'Tipos de Conferência', key: 'access_sub_conference_types' }
                        ]
                    },
                    { label: 'Tipos de Avaliação', key: 'access_tab_types', defaultAdm: true },
                    { label: 'Pessoas', key: 'access_tab_collab' },
                    { 
                        label: 'Parâmetros Avaliação', 
                        key: 'access_tab_config', 
                        defaultAdm: true,
                        children: [
                            { label: 'Métricas Globais', key: 'access_sub_metricas', defaultAdm: true },
                            { label: 'Prazos', key: 'access_sub_deadlines', defaultAdm: true },
                            { label: 'Mensagens PDF', key: 'access_sub_messages', defaultAdm: true },
                            { label: 'Competências', key: 'access_sub_competencias', defaultAdm: true },
                            { label: 'Salário Mínimo', key: 'access_sub_minwage', defaultAdm: true },
                            { label: 'Logomarca', key: 'access_sub_logo', defaultAdm: true },
                            { label: 'Migração / Backup', key: 'access_sub_migration' }
                        ]
                    },
                    {
                        label: 'Usuários',
                        key: 'access_tab_users',
                        children: [
                            { label: 'Gerenciar Usuários (Full)', key: 'access_sub_users_manage' },
                            { label: 'Apenas Aprovar Pendentes', key: 'access_sub_users_approve', defaultAdm: true },
                            { label: 'Auditoria e Logs', key: 'access_tab_audit', defaultAdm: true }
                        ]
                    },
                    { label: 'Cargos e Salários', key: 'access_tab_pcs' },
                    { 
                        label: 'Cadastros do Ponto', 
                        key: 'access_tab_ponto',
                        children: [
                            { label: 'Aba: Regras Gerais (Jornada)', key: 'access_sub_ponto_rules' },
                            { label: 'Aba: Situações (Justificativas)', key: 'access_sub_ponto_sits' },
                            { label: 'Aba: Configurações de Notificações', key: 'access_sub_ponto_settings', defaultAdm: true }
                        ]
                    },                     
                    { 
                        label: 'Dados Externos', 
                        key: 'access_tab_training', 
                        children: [
                            { label: 'Cursos e Treinamentos', key: 'access_sub_capacitacoes' },
                            { label: 'Percepção da Equipe', key: 'access_sub_percepcao' },
                            { label: 'Config. Prazos Gestão', key: 'access_sub_collab_area_config', defaultAdm: true }
                        ]
                    },
                    { label: 'Backup e Restore', key: 'access_tab_backup' }
                ]
            },
            { label: 'Ocorrências Técnicas', key: 'access_apt', defaultAdm: true },
            { label: 'Avaliação (Lançamentos)', key: 'access_eval', defaultAdm: true },
            { 
                label: 'Gerencial',
                key: 'access_fin', 
                defaultAdm: true,
                children: [
                    { 
                        label: 'Estimativa Financeira', 
                        key: 'access_tab_proj', 
                        defaultAdm: true,
                        children: [
                            { label: 'Efetivar Promoções', key: 'access_sub_execute_promo' },
                            { label: 'Ver Custos Gestão (Anonimizado)', key: 'access_sub_fin_blind_gestao' }
                        ]
                    },
                    { label: 'Análise Gerencial', key: 'access_tab_analise', defaultAdm: true }
                ]
            },
            {
                label: 'Recursos Humanos (RH)',
                key: 'access_rh',
                defaultAdm: true,
                children: [
                    { label: 'Central de Avaliações', key: 'access_rh_central', defaultAdm: true },
                    { label: 'Acomp. PDIs | Feedbacks', key: 'access_rh_feedbacks', defaultAdm: true },
                    { label: 'Gestão de Talentos', key: 'access_talent', defaultAdm: true },
                    { label: 'Gestão de Pesquisas', key: 'access_rh_surveys', defaultAdm: true },
                    { label: 'Gestão de Cultura Acad', key: 'hr_cultura_acad', defaultAdm: true }
                ]
            },
            {
                label: 'Central do Colaborador (Visualização)',
                key: 'access_collab_center',
                defaultAdm: true,
                children: [
                    { 
                        label: 'Gestão de Ponto (Operacional)', 
                        key: 'collab_tab_time', 
                        defaultAdm: true,
                        children: [
                            { label: 'Aba: Registro de Ponto (Relógio)', key: 'ponto_tab_clock', defaultAdm: true },
                            { label: 'Aba: Banco de Horas', key: 'ponto_tab_bank', defaultAdm: true },
                            { label: 'Aba: Gestão do Ponto (Relatórios)', key: 'ponto_tab_reports', defaultAdm: true },
                            { label: 'Ver Botão: Solicitações (Gestor)', key: 'ponto_btn_requests', defaultAdm: true },
                            { label: 'Ver Botão: Inconsistências (Gestor)', key: 'ponto_btn_inconsistencies', defaultAdm: true },
                            { label: 'Permitir Marcação Manual', key: 'ponto_can_manual', defaultAdm: true },
                            { label: 'Permitir Envio de Justificativas', key: 'ponto_can_justify', defaultAdm: true },
                            { label: 'Permitir Editar Marcações (Batidas)', key: 'ponto_can_edit', defaultAdm: true },
                            { label: 'Permitir Excluir Marcações (Batidas)', key: 'ponto_can_delete', defaultAdm: true },
                            { label: 'Incluir/Editar Observações Manuais', key: 'ponto_edit_manual_obs', defaultAdm: true },
                            { label: 'Excluir Observações Manuais', key: 'ponto_delete_obs', defaultAdm: true },
                            { label: 'Visão Global (Ver Todos Deptos)', key: 'ponto_view_all', defaultAdm: true }
                        ]
                    },
                    { label: 'Produtividade', key: 'access_prod_basic', defaultAdm: true },
                    { label: 'Capacitações', key: 'collab_tab_training', defaultAdm: true },
                    { label: 'Avaliar Gestão', key: 'collab_tab_perception', defaultAdm: true },
                    { 
                        label: 'Pesquisas & Clima', 
                        key: 'access_sub_surveys',
                        children: [
                            { label: 'Responder Pesquisas', key: 'collab_tab_surveys', defaultAdm: true },
                            { label: 'Configurações de Pesquisas (Admin)', key: 'access_surveys_config' }
                        ]
                    },
                    { label: 'Minhas Assinaturas', key: 'collab_tab_signatures', defaultAdm: true },
                    { label: 'Minha Evolução', key: 'collab_tab_growth', defaultAdm: true },
                    { label: 'Reconhecimento (Elogios)', key: 'collab_tab_recognition', defaultAdm: true },
                    { 
                        label: 'AcadCoins (Moeda Virtual)', 
                        key: 'collab_tab_acad_coins', 
                        defaultAdm: true,
                        children: [
                            { label: 'Administrar AcadCoins (Caixa e Gestão)', key: 'acad_coins_admin', defaultAdm: true }
                        ]
                    },
                    { 
                        label: 'Cultura Acad (Normas e Documentos)', 
                        key: 'collab_tab_cultura_acad', 
                        defaultAdm: true,
                        children: [
                            { label: 'Gestor de Cultura Acad (Criar/Liberar Conteúdos)', key: 'manage_cultura_acad', defaultAdm: true }
                        ]
                    },
                    { 
                        label: 'Gestão de Cultura Acad (RH)', 
                        key: 'hr_cultura_acad', 
                        defaultAdm: true 
                    },
                ]
            },
            {
                label: 'Permissões Avançadas',
                key: 'advanced_features_group',
                children: [
                    { label: 'Ver Pessoas do Tipo Gestão em Cadastros', key: 'viewGestaoCadastros' },
                    { label: 'Ver Notas de Calibração', key: 'eval_view_calibration', defaultAdm: true },
                    { label: 'Editar Metas (Pós-Início)', key: 'eval_edit_goals_locked' },
                    { label: 'Visualizar 9-Box', key: 'eval_view_9box', defaultAdm: true },
                    { label: 'Reabrir Avaliações Fechadas', key: 'eval_reopen_cycle' },
                    { label: 'Ignorar Prazos', key: 'eval_bypass_deadlines' },
                    { label: 'Excluir Avaliações', key: 'eval_delete_record' },
                    { label: 'Exibir Gestão no Dashboard/Avaliação', key: 'viewGestaoDashEval' },
                    { label: 'Bloquear Visualização Própria', key: 'eval_block_self_view' },
                    { label: 'Alterar Visão do Sistema (Cards/Lista)', key: 'allow_view_change', defaultAdm: true }
                ]
            }
        ]
    },
    { id: 'mod_20', label: 'Módulo: IRPF (20)', key: 'access_mod_20' },
    { id: 'mod_25', label: 'Módulo: Pastas e GED (25)', key: 'access_mod_25' },
    { id: 'mod_30', label: 'Módulo: Processos e Obrigs (30)', key: 'access_mod_30' },
    { id: 'mod_50', label: 'Módulo: ESG (50)', key: 'access_mod_50' },
    { id: 'mod_55', label: 'Módulo: Mkt (55)', key: 'access_mod_55' },
    { 
        id: 'mod_99', 
        label: 'Módulo: Admin & Configs (99)', 
        key: 'access_mod_99',
        children: [
            { label: 'Aba: Departamentos', key: 'access_adm_dept' },
            { label: 'Aba: Gestores', key: 'access_adm_manager' },
            {
                label: 'Aba: Usuários e Acessos',
                key: 'access_adm_users',
                children: [
                    { label: 'Gerenciar Usuários (Full)', key: 'access_adm_users_manage' },
                    { label: 'Apenas Aprovar Pendentes', key: 'access_adm_users_approve' },
                    { label: 'Auditoria e Logs', key: 'access_adm_audit' }
                ]
            },
            { label: 'Aba: Módulos do Sistema', key: 'access_adm_modules' },
            { label: 'Aba: Logomarca', key: 'access_adm_logos' },
            { label: 'Aba: Integrações (APIs)', key: 'access_adm_api' }
        ]
    },
    { id: 'mod_70', label: 'Módulo: Indicadores (70)', key: 'access_mod_70' }
];
